export function fileExt(name: string) {
  const base = String(name || "").split(/[\\/]/).pop() || "";
  const dot = base.lastIndexOf(".");
  return dot >= 0 ? base.slice(dot + 1).toLowerCase() : "";
}

export function filePreviewKind(mime: string | undefined, name: string) {
  const resolved = String(mime || "").toLowerCase().split(";")[0];
  const ext = fileExt(name);
  if (resolved.startsWith("image/") || ["png", "jpg", "jpeg", "gif", "webp", "avif", "bmp"].includes(ext)) {
    return "image" as const;
  }
  if (resolved === "application/pdf" || ext === "pdf") return "pdf" as const;
  if (
    resolved.includes("wordprocessingml") ||
    resolved === "application/msword" ||
    ext === "doc" ||
    ext === "docx"
  ) {
    return "word" as const;
  }
  return "other" as const;
}

export function fileKindLabel(mime: string | undefined, name: string) {
  const kind = filePreviewKind(mime, name);
  if (kind === "pdf") return "PDF";
  if (kind === "word") return "Word";
  if (kind === "image") return "Image";
  const ext = fileExt(name);
  if (ext === "pptx" || ext === "ppt") return "PowerPoint";
  if (ext) return ext.toUpperCase();
  return "File";
}
